document.addEventListener('DOMContentLoaded', function () {
    const stickyHeader = headerData.sticky_header;
    const headerOffset = headerData.sticky_header_offset;

    const header = document.querySelector('.fb-sticky-header');


    if(stickyHeader) {
        header.style.paddingTop = `${headerOffset}rem`;
    }

    if (header && header.classList.contains('fb-transparent-header')) {
        window.addEventListener('scroll', function () {
            if (window.scrollY > 0) {
                header.classList.remove('fb-transparent-header');
            } else {
                header.classList.add('fb-transparent-header');
            }
        });
    }

    // Check if the sticky header exists
    if (header) {
        window.addEventListener('scroll', function () {
            if (window.scrollY > 50) {
                header.classList.add('scrolled');
            } else {
                header.classList.remove('scrolled');
            }
        });
    }
});
